<template>
  <div class="common-address-info">
    <b-row class="mt-3">
      <!--Address-->
      <b-col
        sm="12"
        md="8"
        lg="4"
      >
        <b-form-group
          :label="`${$tc('global.address')} *`"
          :state="!errors.has($tc('global.address'))"
          :invalid-feedback="errors.first($tc('global.address'))"
        >
          <vt-input
            v-model="data.address"
            v-validate="'required'"
            :name="$tc('global.address')"
            class="form-control-sm"
            :class="{'is-invalid': errors.has($tc('global.address')) }"
          />
        </b-form-group>
      </b-col>
      <!--Postal Code-->
      <b-col
        sm="4"
        md="4"
        lg="2"
      >
        <b-form-group
          :label="`${$tc('global.pc')} *`"
          :state="!errors.has($tc('global.pc'))"
          :invalid-feedback="errors.first($tc('global.pc'))"
        >
          <vt-input
            v-model="data.postalCode"
            v-validate="'required|min:5|max:5'"
            :name="$tc('global.pc')"
            type="number"
            class="form-control-sm"
            :class="{'is-invalid': errors.has($tc('global.pc')) }"
          />
        </b-form-group>
      </b-col>
      <!--Country combo-->
      <b-col
        sm="8"
        md="4"
        lg="2"
      >
        <b-form-group
          :label="`${$tc('global.country')} *`"
          :state="!errors.has($tc('global.country'))"
          :invalid-feedback="errors.first($tc('global.country'))"
        >
          <vt-combo-select
            v-model="data.country"
            v-validate="'required'"
            :name="$tc('global.country')"
            :allow-empty="false"
            :option-loader="loadCountries"
            label="name"
            :class="{'is-invalid': errors.has($tc('global.country')) }"
            @input="onSelectCountry"
            @remove="clearProvince"
          />
        </b-form-group>
      </b-col>
      <!--Country province-->
      <b-col
        sm="6"
        md="4"
        lg="2"
      >
        <b-form-group
          :label="`${$tc('global.province')} *`"
          :state="!errors.has($tc('global.province'))"
          :invalid-feedback="errors.first($tc('global.province'))"
        >
          <vt-combo-select
            v-model="data.province"
            v-validate="'required'"
            :name="$tc('global.province')"
            :allow-empty="false"
            :disabled="!data.country"
            :options="provinces"
            label="name"
            :class="{'is-invalid': errors.has($tc('global.province')) }"
            @input="onSelectProvince"
            @remove="clearMunicipality"
          />
        </b-form-group>
      </b-col>
      <!--Municipalities combo-->
      <b-col
        sm="6"
        md="4"
        lg="2"
      >
        <b-form-group
          :label="`${$tc('global.municipality')} *`"
          :state="!errors.has($tc('global.municipality'))"
          :invalid-feedback="errors.first($tc('global.municipality'))"
        >
          <vt-combo-select
            v-model="data.municipality"
            v-validate="'required'"
            :name="$tc('global.municipality')"
            :allow-empty="false"
            :disabled="!data.province"
            :options="municipalities"
            label="name"
            :class="{'is-invalid': errors.has($tc('global.municipality')) }"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import countryResource from '@/api/resources/CountryResource'
import provinceResource from '@/api/resources/ProvinceResource'
import municipalityResource from '@/api/resources/MunicipalityResource'

export default {
    name: 'CommonAddressInfo',
    inject: ['formValidator'],
    props: {
        data: { type: Object, required: false }
    },
    data() {
        return {
            countries: [],
            provinces: [],
            municipalities: []
        }
    },
    computed: {
    },
    created() {
        this.$validator = this.formValidator
    },
    async mounted() {
        await this.loadOptions(this.data.country.id, this.data.province.id)
    },
    methods: {
        async loadOptions(couId, proId) {
            if (couId) this.provinces = await this.loadProvinces(couId)
            if (proId) this.municipalities = await this.loadMunicipalities(proId)
        },
        async loadCountries() {
            return countryResource.index()
        },
        async loadProvinces(couId) {
            return provinceResource.index(couId)
        },
        async loadMunicipalities(proId) {
            return municipalityResource.index(proId)
        },
        async onSelectCountry(country) {
            this.provinces = await this.loadProvinces(country.id)
            this.data.province = null
            this.data.municipality = null
        },
        async onSelectProvince(province) {
            this.municipalities = await this.loadMunicipalities(province.id)
            this.data.municipality = null
        },
        clearProvince() {
            this.clearMunicipality()
            this.data.province = null
            this.provinces = []
        },
        clearMunicipality() {
            this.data.municipality = null
            this.municipalities = []
        }
    }
}

</script>
